import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { GlobalService } from 'src/app/services/global.service';
import { AdvisorCardComponent } from '../_components/advisor-card/advisor-card.component';

@Component({
    selector: 'app-advisor-list',
    templateUrl: './advisor-list.component.html',
    styleUrls: ['./advisor-list.component.scss'],
    imports:[AdvisorCardComponent]
})
export class AdvisorListComponent implements OnInit {

  title = "Investing for Catholics Financial Advisors";

  advisors = [];

  constructor(private dataservice: DataServiceService, private seoservice: SeoService, private meta: Meta, private globalservice: GlobalService, private cdr: ChangeDetectorRef) { 

    this.dataservice.getAdvisor("?$filter=id in ("+globalservice.advisors.map(x=> x.id)+")").subscribe(resp => {
      resp = resp.map( x => { 
        x.imageUrl?(x.imageUrl = x.imageUrl.replace("329x461", "270x378")):(null); 
        x.url=(x.url.replace("https://www.ifa.com/",""));
        // 25-01, Mary's title to add co-founder
        (x.id == 28) && (x.title = "Vice President, Wealth Advisor and Co-Founder");
        return x });
 
        this.advisors = resp;
        this.cdr.detectChanges();


        this.dataservice.getClientServices("?$filter=id%20eq%2069").subscribe(resp => {
          resp = resp.map( y => { 
            y.imageUrl?(y.imageUrl = y.imageUrl.replace("329x461", "270x378")):(null);
            
            //adapting IFA.com CSS api for IFC, not great
            y.url=(y.url.replace("https://www.ifa.com/","").replace("about/", "").replace("-brunson", ""))
            return y });
      
            if(resp.length > 0)
            {
              this.advisors.push(resp[0]);
              this.cdr.detectChanges();
            }
       })
      //console.log(resp);
   });

   

  console.log(this.advisors);

  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'investing for catholics advisors, ifc advisors, catholic financial advisors'});
    this.meta.addTag({name: 'description', content: 'Investing gor Catholics Financial Advisors.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
